export const getSizeOfData = (data: unknown): number => {
    const size: number = new TextEncoder().encode(JSON.stringify(data)).length
    const kiloBytes: number = size / 1024;
    return kiloBytes
}